import { useState, useEffect } from 'react'
import { Link } from 'react-router'
import { Menu, X } from 'lucide-react'

const navLinks = [
  { label: 'Features', href: '/features' },
  { label: 'How It Works', href: '/how-it-works' },
  { label: 'Coverage', href: '/coverage' },
  { label: 'Guides', href: '/guides' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Contact', href: 'mailto:hello@procuralerts.com' },
]

export default function Header() {
  const [scrolled, setScrolled] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50)
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const closeMobile = () => setMobileOpen(false)

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 h-16 transition-all duration-300 ${
          scrolled
            ? 'bg-[rgba(13,17,23,0.85)] backdrop-blur-xl border-b border-white/[0.06]'
            : 'bg-transparent border-b border-transparent'
        }`}
      >
        <div className="max-w-[1280px] mx-auto h-full flex items-center justify-between px-6">
          <Link to="/" className="flex items-center gap-0 text-xl font-semibold tracking-tight">
            <span className="text-white">Procur</span>
            <span className="text-[#ef4444]">Alerts</span>
            <span className="ml-1 w-1.5 h-1.5 rounded-full bg-[#ef4444] animate-blink inline-block" />
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                onClick={closeMobile}
                className="text-xs font-mono uppercase tracking-[0.08em] text-[#9ca3af] hover:text-[#06b6d4] transition-colors duration-200"
              >
                {link.label}
              </a>
            ))}
            <a
              href="https://app.procuralerts.com/bids"
              className="text-xs font-mono uppercase tracking-[0.08em] text-[#9ca3af] hover:text-[#06b6d4] transition-colors duration-200"
            >
              Browse Live Bids
            </a>
            <a
              href="https://app.procuralerts.com/login"
              className="text-xs font-mono uppercase tracking-[0.08em] text-[#9ca3af] hover:text-white transition-colors duration-200"
            >
              Log in
            </a>
            <a
              href="https://app.procuralerts.com/register"
              className="bg-[#06b6d4] text-[#0d1117] text-sm font-semibold px-5 py-2.5 rounded-lg hover:bg-[#22d3ee] transition-all duration-200 hover:shadow-[0_0_20px_rgba(6,182,212,0.3)]"
            >
              Start for free
            </a>
          </nav>

          <button
            className="md:hidden text-white p-2"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </header>

      {mobileOpen && (
        <div className="fixed inset-0 z-[60] bg-[#0d1117] flex flex-col items-center justify-center gap-8">
          <button
            className="absolute top-5 right-5 text-white p-2"
            onClick={() => setMobileOpen(false)}
            aria-label="Close menu"
          >
            <X size={24} />
          </button>
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={closeMobile}
              className="text-xl text-[#9ca3af] hover:text-[#06b6d4] transition-colors"
            >
              {link.label}
            </a>
          ))}
          <a
            href="https://app.procuralerts.com/bids"
            onClick={closeMobile}
            className="text-xl text-[#9ca3af] hover:text-[#06b6d4] transition-colors"
          >
            Browse Live Bids
          </a>
          <a
            href="https://app.procuralerts.com/login"
            className="text-xl text-[#9ca3af] hover:text-white transition-colors"
          >
            Log in
          </a>
          <a
            href="https://app.procuralerts.com/register"
            className="bg-[#06b6d4] text-[#0d1117] text-lg font-semibold px-8 py-3 rounded-lg mt-4"
          >
            Start for free
          </a>
        </div>
      )}
    </>
  )
}
